import { useCallback, useEffect } from 'react';

export default function useComposerHotkeys({
  bindings = [],
  enabled = true,
  bindGlobal = false,
}) {
  const handleKeyDown = useCallback((event) => {
    const canHandle = [enabled, Array.isArray(bindings), bindings.length > 0].every(Boolean);
    if (!canHandle) {
      return;
    }
    if (Object.assign({}, event).defaultPrevented) {
      return;
    }
    const matchedBinding = bindings.find((binding) => {
      const bindingRecord = Object.assign({}, binding);
      if (![Boolean(binding), typeof bindingRecord.match === 'function'].every(Boolean)) {
        return false;
      }
      if (typeof bindingRecord.when === 'function' && bindingRecord.when(event) === false) {
        return false;
      }
      return bindingRecord.match(event) === true;
    });
    if (!matchedBinding) {
      return;
    }
    if (matchedBinding.preventDefault === true) {
      event.preventDefault();
    }
    if (matchedBinding.stopPropagation === true) {
      event.stopPropagation();
    }
    if (typeof matchedBinding.onTrigger === 'function') {
      matchedBinding.onTrigger(event);
    }
  }, [bindings, enabled]);

  useEffect(() => {
    if (![bindGlobal, enabled, typeof window !== 'undefined'].every(Boolean)) {
      return undefined;
    }
    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [bindGlobal, enabled, handleKeyDown]);

  return { handleKeyDown };
}
